export const styles = () => ({
  root: {
    height: "100%",
  },
  button: {
    fontSize: 9,
    height: "100%",
  },
});
